import PropTypes from 'prop-types';
import React from 'react';
import ComingSoonModal from './index';

/**
 * GenericComingSoon - A pre-configured Coming Soon modal for features without specific details
 * All content is pre-baked and generic.
 *
 * Usage:
 * <GenericComingSoon>
 *   <ButtonV2>View Analytics</ButtonV2>
 * </GenericComingSoon>
 */
const GenericComingSoon = ({ children }) => {
  return (
    <ComingSoonModal
      title="Coming Soon"
      description="We're working hard to bring you new features and improvements. Stay tuned!"
      features={[
        'Enhanced functionality',
        'Improved user experience',
        'Seamless integration with existing tools',
      ]}
    >
      {children}
    </ComingSoonModal>
  );
};

GenericComingSoon.propTypes = {
  /** Trigger element (button/link) that opens the modal */
  children: PropTypes.element.isRequired,
};

export default GenericComingSoon;
